import React, { useRef, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import rice from '../../../../images/raw_material/rice.png';
import axios from 'axios';

const Consumption_History = ({ show, onClose, data }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // Fetch consumption history
    const fetchData = () => {
        if (!data?.rawmaterials_id) return;

        axios.get(`${baseURL}/stock/raw_consumption_list/${data.rawmaterials_id}`)
            .then(response => {
                setData(response.data.data || []);
                setHasFetched(true);
            })
            .catch(error => {
                console.error('Error fetching consumption data:', error);
                setHasFetched(true);
            });
    };

    useEffect(() => {
        fetchData();
    }, [data]);

    const onInit = () => {};

    const tableRef = useRef(null);
    useEffect(() => {
        if (hasFetched && tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    responsive: true,
                    ordering: false,
                    paging: false,
                    scrollY: '250px',
                    scrollCollapse: true,
                    language: { lengthMenu: 'Show _MENU_' },
                    dom:
                        "<'row'<''<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>>>" +
                        "<'table-responsive'tr>" +
                        "<'row'<''<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>>>"
                });
            }
        }
    }, [hasFetched]);

    const formatDate = (date) => {
        if (!date) return '-';
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <Modal show={show} size="lg">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Consumption History</h3>
                    <Button variant="" type="button" className="close px-6 py-1" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>

                <div className="modal-body">
                    <div className="row mb-2">
                        {/* Raw Material Image */}
                        <div className='col-lg-2'>
                            <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                                <div data-src={data?.image_url || rice}>
                                    <img
                                        src={data?.image_url || rice}
                                        alt={data?.rawmaterial_name || 'Raw Material'}
                                        className='w-100px h-120px'
                                    />
                                </div>
                            </LightGallery>
                        </div>

                        {/* Raw Material Info */}
                        <div className='col-lg-10'>
                            <div className='row'>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Raw Material</label>
                                    <label className='text-danger fs-6 font-w500'>{data?.rawmaterial_name || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Category</label>
                                    <label className='text-black fs-6 font-w500'>{data?.rawmaterial_category || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Unit (Brand)</label>
                                    <label className='text-black fs-6 font-w500'>
                                        {data?.unit || '-'} ({data?.brand || '-'})
                                    </label>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Purchase Date</label>
                                    <label className='text-black fs-6 font-w500'>{formatDate(data?.purchased_date)}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Purchase Qty</label>
                                    <label className='text-black fs-6 font-w500'>
                                        {data?.purchased_qty ?? '0'} {data?.unit || '-'}
                                    </label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Expiry Date</label>
                                    <label className='text-black fs-6 font-w500'>
                                        {data?.expiry_period != null ? `${data.expiry_period} Days` : '-'}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Consumption Table */}
                    <div className="table-container">
                        <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                            <thead>
                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className='min-w-100px text-start'>Date</th>
                                    <th className='min-w-100px text-center'>Consumption Qty / Units</th>
                                    <th className='min-w-100px text-center'>Stock Qty / Units</th>
                                </tr>
                            </thead>
                            <tbody>
                                {datas?.map((val, index) => (
                                    <tr key={index}>
                                    <td className='text-black'>
                                        {val?.last_purchase_date ? formatDate(val.last_purchase_date) : '-'}
                                    </td>
                                    <td className='text-black' align='center'>
                                        {val?.quantity != null && val?.quantity_unit_name
                                            ? `${val.quantity} ${val.quantity_unit_name}`
                                            : '-'}
                                    </td>
                                    <td className="text-black" align="center">
                                        {val?.current_stock != null && val?.quantity_unit_name
                                            ? `${parseFloat(Number(val.stock_quantity).toString())} ${val.quantity_unit_name}`
                                            : '-'}
                                    </td>
                                    </tr>
                                ))}
                                </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Consumption_History;
